export const updateComplaintCount = (complaintCount) => (dispatch) => {
  dispatch({
    type: 'UPDATE_COMPLAINT_COUNT',
    response: { complaintCount }
  })
}